"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableBodyScroll = exports.disableBodyScroll = exports.default = exports.clearAllBodyScrollLocks = void 0;
var _bodyScrollLock = require("body-scroll-lock");
require("./index.css");
let scrollPosition = 0;
const lock = function () {
  const body = document.querySelector("body");
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    scrollPosition = window.pageYOffset;
    body.style.top = `-${scrollPosition}px`;
    body.classList.add("body-scroll-lock__IOS");
  }
  body.classList.add("body-scroll-lock");
};
const unlock = function () {
  const body = document.querySelector("body");
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  body.classList.remove("body-scroll-lock");
  if (isIOS) {
    body.classList.remove("body-scroll-lock__IOS");

    // Disable Smooth Scroll
    // document.body.style.scrollBehavior = 'auto';
    // document.documentElement.style.scrollBehavior = 'auto';

    // // Restore position
    // body.style.removeProperty('top');
    // window.scrollTo(0, scrollPosition);

    // // Restore Smooth Scroll
    // document.body.style.scrollBehavior = '';
    // document.documentElement.style.scrollBehavior = '';
  }
};
const disableBodyScroll = function () {
  lock();
  (0, _bodyScrollLock.disableBodyScroll)(...arguments);
};
exports.disableBodyScroll = disableBodyScroll;
const enableBodyScroll = function () {
  unlock();
  (0, _bodyScrollLock.enableBodyScroll)(...arguments);
};
exports.enableBodyScroll = enableBodyScroll;
const clearAllBodyScrollLocks = function () {
  unlock();
  (0, _bodyScrollLock.clearAllBodyScrollLocks)(...arguments);
};
exports.clearAllBodyScrollLocks = clearAllBodyScrollLocks;
var _default = exports.default = {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
};